import domWrap from "../utils/domWrap";
import formField from "../utils/formField";
import http from '../utils/http';
import h from "../utils/htm";

export default async form => { // 'form[dynamic]'
	const formType = form.getAttribute('type');

	const { default: InputMask } = await import('inputmask'),
		phoneMask = new InputMask('999-999-9999'),
		textInput = 'input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"])',
		fieldSets = [...form.querySelectorAll(':scope fieldset')];
	const fnSetMask = (input) => {
		if (input) phoneMask.mask(input);
	};
	
	let page = 0;
	connectLabels(form);
	[...form.querySelectorAll('script[type="fields"]')].forEach(fieldData => fieldData.replaceWith.apply(fieldData,eval(fieldData.textContent).map(field => formField(field).Node)));

	domWrap(form).on('click', 'button[duplicate]',function(event){
		const 	button = domWrap(this),
				set = (button.data('set') || 1) + 1,
				wrap = h(button.getAttribute('wrap') || 'div added').Node;

		event.preventDefault(); 

		button.getAttribute('duplicate').split(',').forEach(name => {
			const 	clone = domWrap(button.closest('fieldset')?.querySelector('[name="'+name+'"]')?.closest('[field]')?.cloneNode(true)),
					label = clone.querySelector('label'),
					input = clone.querySelector('[name]'),
					id = [label?.getAttribute('for'), '_', set].join('');
			if(!input) return false;
			label.setAttribute('for',id);
			input.setAttribute('id',id);
			label.innerHTML = incInStr(label.innerHTML,set);
			input.setAttribute('placeholder',incInStr(input.getAttribute('placeholder'),set));
			input.setAttribute('name',incInStr(input.getAttribute('name'),set));
			clone.classList.remove('filled');
			clone.querySelector('[name]').value = '';
			wrap.appendChild(clone);
		});

		button.before(wrap);
		[...wrap.querySelectorAll('input[type="tel"]')].forEach(input => fnSetMask);
		button.data('set',set);
	})
	.on('keyup','input,textarea',filledIn)
	.on('change',textInput+',select',filledIn)
	.on('change','[data-action]',function(){
		const 	value = this.dataset.negate ? !this.checked : this.checked;
		[...document.querySelectorAll(this.dataset.target)].forEach(item => item[this.dataset.action] = value);
	})
		.addEventListener('submit', event => {			
			const btn = event.submitter ? event.submitter : {
				classList: {
					add: () => { },
					remove: () => { }
				}
			};	
			
			const validation = getValidateForm(formType, form);

			if (!validation.validate()) {
				event.preventDefault();
				return false;
			}

			const captchaKey = form.querySelector('script[type="recaptcha"]')?.getAttribute('key'),
				  captchaToken = form.querySelector('input[name="token"]')?.value;
			
			if ((captchaKey && captchaKey !== '') && (!captchaToken || captchaToken === '')){
				event.preventDefault();
				grecaptcha.ready(() => {
					grecaptcha.execute(captchaKey, {action: 'submit'}).then( token => {
						form.appendChild(h(`input name="token" type="hidden" value="${token}"`).Node);
						form.submit();
					});
				});	
				return;
			}

			if(form.hasAttribute('fullpost')) return;

			event.preventDefault();

			var getData = form.getAttribute('format') === 'string' ?
				() => ({ obj: JSON.stringify(new FormData(form)) }) :
				() => new FormData(form);
			
			form.classList.add('loading');
			btn.classList.add('processing');

			http('/' + form.getAttribute('type')).create(formData(form,form.getAttribute('format'))).then(() => {
				var thankyou = form.querySelector('.thankyou');
				if(thankyou.getAttribute('href')){
					window.location = thankyou.getAttribute('href');
				}
				else {
					form.innerHTML = thankyou.innerHTML;
					form.classList.remove('loading');
					btn.classList.remove('processing');
				}
				if((navigator.userAgent || navigator.vendor || window.opera).match( /Android/i )){
					setTimeout(() => document.body.scrollTop = form.offsetTop - 70,100);
				}
			}).catch(() => {
				form.querySelector('.errors').innerHTML = h('p','There was an error submitting. Please check your connection and try again.');
				form.classList.remove('loading');
				btn.classList.remove('processing');
			});
	});
	
	[...form.querySelectorAll(textInput+',select')].forEach(input => filledIn.call(input));

	/*
	if(form.hasAttribute('paged')){
		form.querySelector('footer').prepend(h('nav',
			h('button action="prev"','Previous')
			('button action="next"','Next')
		).Node);
		domWrap(form).on('click','footer > nav button',function(e){
			e.preventDefault();

			if(checkRequired(fieldSets[page],form.querySelector('.errors'))){
				return;
			}

			switch(this.getAttribute('action')){
				case 'prev':
					page = page > 0 ? page-1 : page;
					break;
				case 'next':
					page = page < fieldSets.length - 1 ? page + 1 : page;
					break;
			}
			pageNav(form,fieldSets,page);
		});
		pageNav(form,fieldSets,page);
	}
	*/
};

function connectLabels(form){
	[...form.querySelectorAll('label:not([for])')].forEach(label => {
		var named = label.parentNode.querySelector('[name]'),
			id = named.getAttribute('id') || uniqueId(named.getAttribute('name'));
		named.setAttribute('id', id);
		label.settAttribute('for', id);
	});
}

function formData(form,type) {
	const serialized = (new URLSearchParams(new FormData(form))).toString();
	return type === 'string' ? ({ obj: JSON.stringify(serialized) }) : serialized;
}

function uniqueId(id,current = 0){
	var idCheck = id + (current === 0 ? '' : '-' + current);
	return document.getElementById(idCheck) ? uniqueId(id,current+1) : idCheck;
}

function incInStr(str = '',inc,base = 1){
	return str?.split(base.toString()).join(inc) || '';
}

function filledIn(){
	this.closest('[field]')?.classList.toggle('filled',(this.value || '').trim() !== '');
}

/*
function pageNav(container,fieldSets,page){
	var current = fieldSets[page];
	container.classList.toggle('no-prev',page === 0);
	container.classList.toggle('no-next',page === fieldSets.length - 1);
	domWrap(current).setSelected();
}


function checkRequired(container,errorsContainer){
	var errorsList = [...container.querySelectorAll('.validate:enabled')].map((item) => {
		const field = item.closest('[field]');
		if (
			(item.getAttribute('type') === 'checkbox' && !item.checked) ||
			((item.value || '').trim() === '')
		) {
			field.classList.add('invalid');
			return h('p',(item.placeholder || item.parentNode.querySelector('label').textContent.replace('*','')) + ' Required');
		}
		else {
			field.classList.remove('invalid');
			return '';
		}
	}).join('');
	errorsList += (errorsContainer.getAttribute('one-required')?.split(',') || []).map(item => {
		const set = item.split('|');
		return document.querySelectorAll('input[name="'+set[0]+'"]:checked').length === 0 ? h('p',set[1]) : '';
	}).join('');

	errorsContainer.innerHTML = errorsList;
	return errorsList.length > 0;
}
*/

function getValidateForm(formType, form){
	return formType === 'Newsletter' 
		? new DefaultValidateForm(form, formType)
		: new ValidateForm(form);
}

class ValidateForm {
	constructor(form) {
		this.Form = form;
	}

	validate() { }
}

class DefaultValidateForm extends ValidateForm {
	constructor(form, formType) {
		super(form);

		this.emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		this.num8Regex = /^[0-9]{8}$/;
		this.formType = formType;
		const messageContainer = this.Form.querySelector('.errors');			
		this.MessageContainer = messageContainer
			? messageContainer
			: { innerHTML: '' };
	}

	fieldListEvent(event, target) {
		const field = target ? target : event.target;

		const isValid = this.processField(field);
	}

	processField(field) {
		const isValid = this.validateField(field);

		if (isValid)
			this.setFieldToValid(field);
		else
			this.setFieldToInvalid(field);

		return isValid;
	}

	setEventListener(field) {
		const validateType = field.getAttribute('requiredtype');

		switch (validateType) {
			case 'dealer':
				const eventField = document.getElementById('DealerCode');
				if (eventField)
					eventField.addEventListener
						('dealer-change', (event) => { this.fieldListEvent(event, field); });
				break;

			default:
				field.addEventListener
					('blur', (event) => { this.fieldListEvent(event, field) });
				break;
		}
	}

	setFieldToInvalid(field) {

		const parent = field.parentElement;

		if(parent)
			parent.classList.add('invalid');

		this.setEventListener(field);

		const msg = field.getAttribute("invalidmessage");
		if (window.tippy && msg && msg !== '') {
			const options = {
				content: msg,
				trigger: 'focusin',
				placement: 'top-start'
			};
			
			tippy(field, options);
		}
	}

	setFieldToValid(field) {
		const parent = field.parentElement;
		if(parent)
			parent.classList.remove('invalid');
	}

	setFocus(field) {
		const validateType = field.getAttribute('requiredtype');

		switch (validateType) {
			case 'dealer':
				const locationField = document.getElementById('DealerLocation');
				if (locationField)
					locationField.focus();
				break;

			default:
				field.focus();
				break;
		}
	}

	validate() {
		try {
			const errorFields = [];
			const fields = [...this.Form.querySelectorAll('[validate="onsubmit"]')];

			for (let i = 0, l = fields.length; i < l; i++) {
				const isValid = this.processField(fields[i]);
				if (!isValid)
					errorFields.push(fields[i]);
			}

			if (errorFields.length > 0) {
				this.setFocus(errorFields[0]);
				return false;
			}

			return true;

		} catch (exception) {
			console.error(exception);
			return false;
		}
	}

	validateEmail(value) {
		if (typeof value === 'string')
			return value.match(this.emailRegex);
		return false;
	}

	validateField(field) {
		const validateType = field.getAttribute('requiredtype');

		switch (validateType) {
			case 'email':
				return this.validateEmail(field.value);

			case 'dealer':
				const dealerCodeField = document.getElementById('DealerCode');
				const dealerCode = dealerCodeField ? dealerCodeField.value : '';
				return this.validateText(dealerCode);

			case 'num8Pattern':
				return this.validateNum8(field.value);

			case 'postalcode':
				return this.validatePostalCode(field.value);

			case 'tel':
				return this.validatePhone(field.value);

			case 'sel':
			case 'text':
				return this.validateText(field.value);
		}

		return true;
	}

	validateNum8(value) {
		const str = typeof value === 'string'
			? value
			: String(value);

		if (str.length > 0)
			return str.match(this.num8Regex);

		return true;
	}

	validatePhone(value) {
		let phone = typeof value === 'string'
			? value
			: String(value);

		phone = phone.replace(/\D/g, '');

		return phone.length >= 10;
	}

	validatePostalCode(value) {
		const code = typeof value === 'string'
			? value
			: String(value);

		return code.length > 4;
	}

	validateText(value) {
		if (typeof value === 'string')
			return value.length > 1;
		return false;
	}
}